module.exports = __webpack_public_path__ + "img/gsjjleftBox.fcfce0ae.png";